<template>
  <div class="app-container body-box">
    <!-- 搜索与添加区域 -->
    <el-row style="padding: 20px">
      <el-col :span="19">
        <el-button
            icon="el-icon-plus"
            style="margin-bottom: 10px"
            @click="addTemplate"
        >新增
        </el-button>
      </el-col>
      <el-col :span="5" class="search">
        <el-input
            v-model="queryInfo.keyword"
            clearable
            placeholder="请输入关键字进行搜索"
        >
          <el-button
              slot="suffix"
              icon="el-icon-search"
              @click="handleQuery"
          ></el-button>
        </el-input>
      </el-col>


      <el-table :data="templateList" style="padding-top: 10px;" class="button-box">
        <el-table-column label="模板名称" prop="name"></el-table-column>
        <el-table-column label="模板路径" prop="path"></el-table-column>
        <el-table-column label="模板内容" prop="content"></el-table-column>
        <el-table-column label="模板关键字" prop="keyword"></el-table-column>
        <el-table-column label="模板备注" prop="brief"></el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-button
                icon="el-icon-edit"
                size="mini"
                @click="edtiTemplate(scope.row)"
            >修改
            </el-button>
            <!-- 删除按钮 -->
            <el-button
                icon="el-icon-delete"
                size="mini"
                @click="removeTemplateById(scope.row.id)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <pagination ref="page" @pagination="getTemplateList"/>
    </el-row>
    <addTemplate @refresh-list="handleQuery" ref="addTemplate"></addTemplate>
    <editTemplate @refresh-list="handleQuery" ref="editTemplate"></editTemplate>
  </div>
</template>
<script>
import Pagination from '@/components/common/Pagination/index'
import addTemplate from "@/views/template/addTemplate";
import editTemplate from "@/views/template/editTemplate";
import {getData, getPostOrDeleteData} from "@/utils/code";
import {deleteTemplate, getTemplateList} from "@/api/template/template";
import {deleteTips, title} from "@/utils/tips";

export default {
  components: {Pagination, addTemplate, editTemplate},
  data() {
    return {
      // 查询参数
      queryInfo: {
        keyword: "",
      },
      templateList: [],
      refreshLoading: false,
      searchCodeOrNameLoading: false,
      fullscreenLoading: false,
      index: 0,
    };
  },
  created() {

  },
  methods: {
    /**
     * 查询列表
     */
    getTemplateList(page, cb) {
      getTemplateList(page).then((response) => {
        let data = getData(response)
        this.templateList = data ? data.records : [];
        //回调返回总数
        if (cb) cb(Number(data.total));
      })
    },
    /**
     * 根据ID删除数据
     */
    async removeTemplateById(id) {
      let b = await deleteTips(title.deleteTitle);
      if (b) {
        deleteTemplate(id).then((response) => {
          let data = getPostOrDeleteData(response);
          if (data !== null) {
            this.handleQuery()
          }
        })
      }
    },
    /**
     * 新增
     */
    addTemplate() {
      this.$refs.addTemplate.addDialog()
    },
    /**
     *  修改
     */
    edtiTemplate(row) {
      this.$refs.editTemplate.editDialog(row)
    },
    /**
     * 查询按钮
     */
    handleQuery() {
      this.$refs.page.selectList(1, null, this.queryInfo)
    },

  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  padding-right: 30px;
}
</style>
